<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To the many ‘Lanny Budd’ lovers all over</i></span></p>
<p class="ded1"><span><i>the world who have written letters</i></span></p>
<p class="ded1"><span><i>asking me to write this book</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?50ffac6c